export default __webpack_public_path__ + "static/media/INXC_logo.cad2c7ae.png";